import { Logo } from '../components/Logo'
import styled from 'styled-components';
import { Aco } from '../components/Aco';

const data = [
  {en: "1,8-cineole", ja: "1,8-シネオール", rebge: "Max:6", value: "3.91%"},
  {en: "Limonene", ja: "リモネン", rebge: "Max:7", value: "4.08%"},
  {en: "Linalool", ja: "リナロール", rebge: "20-45", value: "42.13%"},
  {en: "Camphor", rebge: "Max1.4", value: "0.07%"},
  {en: "Terpinen-4-ol", rebge: "0.1-6.0", value: "2.64%"},
  {en: "Alpha-terpineol", rebge: "Trace to 7", value: "0.03%"},
  {en: "Linalyl acetate", rebge: "25-46", value: "33.87%"},
]

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`

const LeftLayout = styled.div`
  float: left;
  padding: 0 0 40px 0;
  @media screen and (min-width:960px) {
    width: 545px;
  }
`

const RightLayout = styled(LeftLayout)`
  @media screen and (min-width:960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`

const NumberData = styled.td`
  text-align: right;
`

export const Lavandula = () => <Layout>
<LogLayout><Logo /></LogLayout>
<LeftLayout>
<h2>使用期限</h2>
<p>{new Date('2024-08-31T15:00:00.000Z').toLocaleDateString()}</p>
<h2>Certification of analysis</h2>
<h3>1. PRODUCT IDENTIFICATION AND COMPOSITION</h3>
<ul>
  <li>1.1 Product Name: Lavender Oil CG</li>
  <li>1.2 Botanical Name: Lavandula angustifolia</li>
</ul>
<h3>2. PHYSICAL AND CHEMICAL PROPERTIES</h3>
<ul>
  <li>2.1 Appearance: Clear, pale yellow to yellow liquid Conforms</li>
  <li>2.2 Odour: Characteristic Conforms</li>
  <li>2.3 Specific Gravity: 0.8780 to 0.8950 @ 20°C Conforms</li>
  <li>2.4 Refractive Index: 1.4550 to 1.4660 @ 20°C Conforms</li>
</ul>
<p>CONSTITUENT SPECIFICATION RESULT</p>
<h3>3. GAS CHROMATOGRAPH ANALYSIS Results</h3>
<table>
  <tbody>
    {data.map((item, index) => <tr key={index}>
      <th>{item.en}</th><NumberData>{item.value}</NumberData>
    </tr>)}
  </tbody>
</table>
</LeftLayout>
<RightLayout>
  <Aco />
</RightLayout>
</Layout>